import { tns } from '../thirdparty/tinyslider/tinyslider.js';

export default class ProdScroller4i {
    constructor() {
        this.sliderWrapper = null;
        this.slider = null;
        this.prevButton = null;
        this.nextButton = null;
        this.xlNumber = 4;
        this.lgNumber = 3;
        this.mdNumber = 2;
        this.starRatingPromise = null;

        this.sliderEvents = this.sliderEvents.bind(this);
    }

    async init(containerID, xlNumber, lgNumber, mdNumber){
		if (!containerID || typeof containerID !== 'string') {
            console.warn("Scroller container ID is missing");
            return;
        }

        this.xlNumber = xlNumber || this.xlNumber;
		this.lgNumber = lgNumber || this.lgNumber;
		this.mdNumber = mdNumber || this.mdNumber;

        await this.setElements(containerID);

        if (!this.slider) {
			console.warn("No slider element found within container:", containerID);
			return;
		}

		const sliderInstance = tns({
            container: this.slider,
            lazyload: true,
            prevButton: this.prevButton,
            nextButton: this.nextButton,
            items: 1, // number items on mobile
            gutter: 10, // space between slides
            slideBy: "page",
            nav: false,
            loop: false,
            arrowKeys: true,
            responsive: {
                1024: { items: this.xlNumber },
                800: { items: this.lgNumber },
                480: { items: this.mdNumber }
            }
        });

        this.slider.classList.remove("invisible");
		this.setLiveRegionRole();
        this.sliderWrapper.addEventListener("click", this.sliderEvents);

		return sliderInstance;
    }

    async setElements(containerID) {
		this.sliderWrapper = document.getElementById(containerID);
		if (!this.sliderWrapper) {
			console.warn(`No element found with ID "${containerID}"`);
			return;
		}

		this.slider = this.sliderWrapper.querySelector('.Scroller');
		this.prevButton = this.sliderWrapper.querySelector('.slider-prev');
		this.nextButton = this.sliderWrapper.querySelector('.slider-next');
		this.scrollerReviewLinks = this.sliderWrapper.querySelectorAll('.miniReviewLink');
	}

    async sliderEvents(e) {
        if (e.target.closest('.miniReviewLink')) {
            e.preventDefault();
            const StarRating = await this.loadStarRatings();
            if (!StarRating) return;
            StarRating.toggle(e);
        }
    }

    setLiveRegionRole() {
        const liveRegion = this.sliderWrapper.querySelector(".tns-liveregion");
        if (liveRegion) liveRegion.setAttribute("role", "status");
    }

    async loadStarRatings() {
		if(this.starRatingPromise){ return this.starRatingPromise.default; }
        try {
            this.starRatingPromise = await import('./starrating25.js');
            return this.starRatingPromise.default; // Return the default export
        } catch (error) {
            console.error("Error in loadStarRatings. Failed to load star rating module:", error);
            this.starRatingPromise = null; // Reset to allow retry on failure
            return null;
        }
	}
}